angular.module('rjmNg.constants')
.constant('email',
  TYPE: Object.freeze
    FULL_UPDATE_COMPLETION: 1
    DERIVATIVE_UPDATE_COMPLETION: 3
    STRUCTURE_SYNC_COMPLETION: 5
    STRUCTURE_SYNC_START: 6
    BACKGROUND_SYNC_COMPLETION: 8
    BACKGROUND_SYNC_START: 9
)
